import {PathUtility} from 'src/shared/constants/PathBuilder';
import React from 'react';

import type {
  CourseSessionSimpleResponse,
  CourseSessionStateEnum,
} from 'src/api/ProactApiClient';
import {DataList} from 'src/design/organisms/DataList';
import {useListState} from 'src/design/organisms/useListState';
import {useGetCourseSessionListQuery} from 'src/redux/queries/courseSession';
import {
  CourseSessionPillConfig,
  TrainingIcon,
} from './coursePills';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

const maxPageRows = 5;

export interface SessionListViewProps {
  assignmentId: number;
  sessionStates: string[];
}
export const SessionListView: React.FC<SessionListViewProps> = ({
  assignmentId,
  sessionStates,
}) => {
  const navigate = useAppNavigate();
  const {currentPage, handlePageChange, start, length} = useListState({
    identifier: `course-assignment-overview-sessions-${assignmentId}`,
    pageSize: maxPageRows,
  });

  const {data, isLoading} = useGetCourseSessionListQuery({
    start,
    length,
    states: sessionStates.map(s => s as unknown as CourseSessionStateEnum),
    assignmentId: assignmentId,
    sortColumn: 'StartedAt',
    sortDirection: 'desc',
  });

  const indexListData = data?.data ?? [];
  const totalRecords = data?.totalRecords ?? 0;

  const handleNavigateTo = (id: string | number) => {
    navigate(PathUtility.TrainingSessionRecord(String(id), 'overview'));
  };

  return (
    <DataList
      rowIcon={TrainingIcon}
      isLoading={isLoading}
      data={indexListData}
      currentPage={currentPage}
      totalRecords={totalRecords}
      recordsPerPage={maxPageRows}
      onRowClick={handleNavigateTo}
      onPageChange={handlePageChange}
      onGetPillMapping={(item: CourseSessionSimpleResponse) =>
        CourseSessionPillConfig(
          item.sessionState,
          item.sessionType,
          item.language
        )
      }
      onRowTextRender={(item: CourseSessionSimpleResponse) =>
        item.internalIdentifier ?? 'Unknown'
      }
      hasSearchTerm={false}
      hasCreationLogic={false}
      meta={undefined}
    />
  );
};
